"use client";

import { Scale } from "@/animations/scale";
import { cn } from "@/utils";
import { useResize } from "@/utils/useResize";
import { cva } from "class-variance-authority";
import { Link } from "react-router-dom";
import { HeaderFinder } from "./header-finder";
import { WrapperFinder } from "./wrapper-finder";

const variants = cva("w-full", {
  variants: {
    twSize: {
      xs: "w-[78%] max-w-[440px] ml-[14px] mt-[120px]",
      sm: "w-[78%] max-w-[440px] ml-[14px] mt-[120px]",
      md: "w-[78%] max-w-[440px] ml-[14px] mt-[120px]",
      lg: "max-w-[388px] ml-[528px] -mt-[100px]",
      xl: "max-w-[401px] ml-[600px] -mt-[106px]",
      "2xl": "max-w-[426px] ml-[637px] -mt-[113px]",
      "3xl": "max-w-[452px] ml-[675px] -mt-[120px]",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

// 120

const variantsContent = cva("text-black font-medium ", {
  variants: {
    twSize: {
      xs: "text-[14px] leading-[1.42]",
      sm: "text-[14px] leading-[1.42]",
      md: "text-[20px] leading-[1.42]",
      lg: "text-[22px] leading-[1.33]",
      xl: "text-[21px] leading-[1.33]",
      "2xl": "text-[22px] leading-[1.33]",
      "3xl": "text-[24px] leading-[1.33]",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

export function FinderCommunity() {
  const { twSize } = useResize();

  // const ANI = useMemo(() => {
  //   return width >= 1024 ? Scale : FadeLeft;
  // }, [width]);

  return (
    <Scale>
      <WrapperFinder className={cn(variants({ twSize: twSize }))}>
        <HeaderFinder>
          <p className="text-[#23262F] text-center text-[13px] font-medium leading-4 truncate led">
            Hold Community
          </p>
        </HeaderFinder>

        <div className={"p-5 md:p-6 flex flex-col gap-4"}>
          <p className={cn(variantsContent({ twSize: twSize }), "pr-4")}>
            Designed by the people, for the people—experience a product shaped
            by your needs.
          </p>

          <div>
            <Link
              to={"https://link3.to/holdstation"}
              target="_blank"
              data-action="redirect_community_holdstation"
              className="px-7 py-3 rounded-full text-white bg-black flex-none text-sm lg:text-base inline-block"
            >
              Join the Community
            </Link>
          </div>
        </div>
      </WrapperFinder>
    </Scale>
  );
}
